import React from 'react';

const VideoSection: React.FC<{video: string}> = ({video}) => {
    return (
        <section className='z-20 py-8 relative before:content-[""] before:w-dvw before:h-1/2 before:bg-[#F3F6FF] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:-z-10'>
            <div className="max-w-screen-lg mx-auto px-4">
                {video &&
                    <div className="max-w-screen-lg mx-auto px-4" id='video'>
                        <div className="w-full" dangerouslySetInnerHTML={{ __html: video }} />
                    </div>
                }
            </div>
        </section>
    );
};

export default VideoSection;